import { Link } from "react-router-dom";
import Logo from "@/components/feature/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#161b22] py-8">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Logo variant="light" />
            <p className="text-xs text-white/40 mt-3 leading-relaxed">
              Connecting clients with verified cybersecurity professionals since 2016. Secure escrow, confidential projects, global talent.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-white/60 mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/hackers" className="text-xs text-white/40 hover:text-[#5bc0de] transition-colors">Find a Hacker</Link></li>
              <li><Link to="/projects-listing" className="text-xs text-white/40 hover:text-[#5bc0de] transition-colors">Browse Projects</Link></li>
              <li><Link to="/post-project" className="text-xs text-white/40 hover:text-[#5bc0de] transition-colors">Post a Project</Link></li>
              <li><Link to="/hacking-news" className="text-xs text-white/40 hover:text-[#5bc0de] transition-colors">Hacking News</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-white/60 mb-3">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-xs text-white/40 hover:text-[#5bc0de] transition-colors">Contact Us</Link></li>
              <li><a href="mailto:support@hackerslodge.com" className="text-xs text-white/40 hover:text-[#5bc0de] transition-colors" rel="nofollow">support@hackerslodge.com</a></li>
              <li><Link to="/payment/crypto" className="text-xs text-white/40 hover:text-[#5bc0de] transition-colors">Crypto Payments</Link></li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-white/60 mb-3">Community</h3>
            <div className="flex items-center gap-3 mb-3">
              <a href="https://twitter.com/hackerslodge" target="_blank" rel="nofollow noopener noreferrer" className="text-white/40 hover:text-[#5bc0de] transition-colors text-sm" aria-label="Hackers Lodge on Twitter">
                <i className="fab fa-twitter text-lg" />
              </a>
              <a href="https://t.me/hackerslodge" target="_blank" rel="nofollow noopener noreferrer" className="text-white/40 hover:text-[#5bc0de] transition-colors text-sm" aria-label="Hackers Lodge on Telegram">
                <i className="fab fa-telegram-plane text-lg" />
              </a>
              <a href="https://github.com/hackerslodge" target="_blank" rel="nofollow noopener noreferrer" className="text-white/40 hover:text-[#5bc0de] transition-colors text-sm" aria-label="Hackers Lodge on GitHub">
                <i className="fab fa-github text-lg" />
              </a>
              <a href="https://reddit.com/r/hackerslodge" target="_blank" rel="nofollow noopener noreferrer" className="text-white/40 hover:text-[#5bc0de] transition-colors text-sm" aria-label="Hackers Lodge on Reddit">
                <i className="fab fa-reddit-alien text-lg" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30 text-center sm:text-left">
            &copy; 2016-2026 Hackers Lodge. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-white/30 hover:text-white/50 transition-colors">Privacy</Link>
            <Link to="/terms" className="text-xs text-white/30 hover:text-white/50 transition-colors">Terms</Link>
            <Link to="/sitemap.xml" className="text-xs text-white/30 hover:text-white/50 transition-colors" rel="nofollow">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}